import { View, Text, StyleSheet } from 'react-native'
import { IProject } from '../../../interfaces/project.interface'
import { getStyleSheet } from '../../../assets/theme/styles'

const Status = ({ project }: { project: IProject }) => {
    const styles = getStyleSheet()

    return (
        <View>
            <Text style={{ color: styles.text }}>Status</Text>
        </View>
    )
}

export default Status

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
})
